import { HttpBackend } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../current-project';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { environment } from '../../../environments/default/environment';

export function HttpLoaderFactory(http: HttpBackend) {
    const path = environment.projectName ? `./assets/languages/${environment.projectName}/` : './assets/languages/';
    if (IS_TRS_PROJECT) {
        return new MultiTranslateHttpLoader(http, [
            { prefix: './assets/languages/', suffix: '.json' },
            { prefix: path, suffix: '.json' }
        ]);
    }

    if (IS_PRODUCT_SAFETY_PROJECT) {
        return new MultiTranslateHttpLoader(http, [
            { prefix: './assets/languages/', suffix: '.json' },
            { prefix: path, suffix: '.json' }
        ]);
    }
}

export class ReportingToolMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        return params.key;
    }
}
